var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "virtualSelectRoot",
      staticClass:
        "se-multiple-select-wrap el-select se-multiple-se virtual-select",
      class: { "is-disabled": _vm.disabled, "is-open": _vm.dropdownVisible },
    },
    [
      _c(
        "div",
        {
          staticClass: "el-input el-input--suffix el-input--mini",
          on: {
            click: function ($event) {
              !_vm.disabled && _vm.toggleDropdown()
            },
          },
        },
        [
          _c("div", { staticClass: "el-input__inner" }, [
            _vm.innerValue.length
              ? _c(
                  "div",
                  { staticClass: "el-select__tags" },
                  _vm._l(_vm.displayTags, function (sel) {
                    return _c(
                      "el-tag",
                      {
                        key: sel.SEID,
                        attrs: {
                          type: "info",
                          size: "mini",
                          closable: "",
                          "disable-transitions": "",
                        },
                        on: {
                          close: function ($event) {
                            $event.stopPropagation()
                            return _vm.removeValue(sel.SEID)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(sel.Name) + " ")]
                    )
                  }),
                  1
                )
              : _c("span", { staticClass: "el-select__placeholder" }, [
                  _vm._v(" " + _vm._s(_vm.placeholder) + " "),
                ]),
            _c("input", {
              staticClass: "el-select__input",
              staticStyle: {
                opacity: "0",
                width: "0",
                height: "0",
                padding: "0",
                border: "none",
              },
              attrs: { type: "text", autocomplete: "off", size: "mini" },
            }),
          ]),
          _c("span", { staticClass: "el-input__suffix" }, [
            _c("span", { staticClass: "el-input__suffix-inner" }, [
              _c("i", {
                staticClass: "el-select__caret el-input__icon el-icon-arrow-up",
                class: { "is-reverse": _vm.dropdownVisible },
              }),
            ]),
          ]),
        ]
      ),
      _c("transition", { attrs: { name: "el-zoom-in-top" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.dropdownVisible,
                expression: "dropdownVisible",
              },
            ],
            ref: "dropdown",
            staticClass: "el-select-dropdown se-multiple-se-dropdown",
            style: _vm.dropdownStyle,
          },
          [
            _vm.filterable
              ? _c(
                  "div",
                  { staticClass: "filter-input-wrap" },
                  [
                    _c("el-input", {
                      attrs: {
                        size: "small",
                        placeholder: "Search",
                        "prefix-icon": "el-icon-search",
                        clearable: "",
                      },
                      nativeOn: {
                        click: function ($event) {
                          $event.stopPropagation()
                        },
                      },
                      model: {
                        value: _vm.filterQuery,
                        callback: function ($$v) {
                          _vm.filterQuery = $$v
                        },
                        expression: "filterQuery",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm.type == "quickPush" && _vm.desiredCertifiedValuesList.length > 0
              ? _c(
                  "div",
                  { staticClass: "wrapper" },
                  [
                    _c(
                      "el-checkbox",
                      {
                        attrs: {
                          indeterminate: _vm.isIndeterminate,
                          disabled: _vm.checkAllDisabled,
                        },
                        on: { change: _vm.handleCheckAllChange },
                        model: {
                          value: _vm.checkAll,
                          callback: function ($$v) {
                            _vm.checkAll = $$v
                          },
                          expression: "checkAll",
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "se-name",
                            class: { checked: _vm.checkAll },
                          },
                          [
                            _vm._v(
                              "Select All (Certified + Pending certification)"
                            ),
                          ]
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.type == "push" && _vm.innerOptions.length > 0
              ? _c(
                  "div",
                  { staticClass: "wrapper" },
                  [
                    _c(
                      "el-checkbox",
                      {
                        attrs: {
                          indeterminate: _vm.isIndeterminate,
                          disabled: _vm.checkAllDisabled,
                        },
                        on: { change: _vm.handleCheckAllChange },
                        model: {
                          value: _vm.checkAll,
                          callback: function ($$v) {
                            _vm.checkAll = $$v
                          },
                          expression: "checkAll",
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "se-name",
                            class: { checked: _vm.checkAll },
                          },
                          [_vm._v("Select All")]
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              {
                staticClass: "el-select-dropdown__wrap el-scrollbar__wrap",
                staticStyle: { "max-height": "274px" },
              },
              [
                _vm.filteredOptions && _vm.filteredOptions.length
                  ? _c(
                      "div",
                      { ref: "listWrap", staticClass: "virtual-list-wrap" },
                      [
                        _c("RecycleScroller", {
                          key: _vm.virtualListKey,
                          staticClass: "scroller",
                          attrs: {
                            items: _vm.filteredOptions,
                            "item-size": 52,
                            buffer: 800,
                            "key-field": "SEID",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ item }) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "multiple-se-item virtual-se-item",
                                        class: {
                                          selected: _vm.isSelected(item),
                                          "is-disabled": _vm.isDisabled(item),
                                        },
                                        attrs: {
                                          title: _vm.showTips
                                            ? _vm.tipTitle(item)
                                            : null,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onItemClick(item)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "virtual-se-item-left",
                                          },
                                          [
                                            _c("span", {
                                              staticClass: "vsi-checkbox",
                                              class: {
                                                "is-checked":
                                                  _vm.isSelected(item),
                                              },
                                            }),
                                            _c(
                                              "span",
                                              { staticClass: "se-name" },
                                              [_vm._v(_vm._s(item.Name))]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "virtual-se-item-right",
                                          },
                                          [
                                            item.types && item.types.length > 0
                                              ? _c(
                                                  "span",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "role",
                                                        rawName: "v-role",
                                                        value: [1, 2, 3, 13],
                                                        expression:
                                                          "[1,2,3,13]",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "vsi-tag vsi-tag--info",
                                                    style: _vm.showTag
                                                      ? "margin-right:8px"
                                                      : "",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(item.types[0])
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm.showTag
                                              ? [
                                                  item.Certified == 2
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "vsi-tag vsi-tag--warning",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Pending certification"
                                                          ),
                                                        ]
                                                      )
                                                    : item.Certified == 1
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "vsi-tag vsi-tag--success",
                                                        },
                                                        [_vm._v("Certified")]
                                                      )
                                                    : _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "vsi-tag vsi-tag--danger",
                                                        },
                                                        [_vm._v("Uncertified")]
                                                      ),
                                                ]
                                              : _vm._e(),
                                          ],
                                          2
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2940676307
                          ),
                        }),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.listLoading,
                                expression: "listLoading",
                              },
                            ],
                            staticClass: "virtual-list-loading",
                          },
                          [
                            _c("i", { staticClass: "el-icon-loading" }),
                            _c("span", [_vm._v("Loading...")]),
                          ]
                        ),
                      ],
                      1
                    )
                  : _c("div", { staticClass: "el-select-dropdown__empty" }, [
                      _vm._v(" 无匹配的数据 "),
                    ]),
              ]
            ),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }